import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

// Is this final. This will raise request in approvals to delete package[irctc-gold] instrument[526] mapping.
// {"id":4,"instrument":"525","packageName":"irctc-gold"}
const getRequestBody = (data: any) => {
  return {
    id: data?.id,
    instrument: data?.instrument,
    packageName: data?.packageName,
  }
}

const deletePackageToInstrument = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingPack2InstDelete),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequestBody(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { deletePackageToInstrument }
